import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import {default as Modal, withModal} from 'components/Modal';

import {fetchRoomDetails} from 'ducks/rooms';
import {MODALS as BASE_MODALS} from 'ducks/modals';
import {HOUSEKEEPING_STATUS_TO_COLOR_MAPPER} from 'ducks/allocations';

import {RoomNotes, RoomHistory} from './components';

import './styles.css';

const NOTES_TAB = 'Notes';
const HISTORY_TAB = 'History';

const TABS = [NOTES_TAB, HISTORY_TAB];

const TabNavigation = ({selectedTab, selectTab}) => (
  <div className="TabNavigation colab-centered-v">
    {TABS.map(tab => (
      <div
        className={classNames(
          'TabNavigation__tab colab-centered-v colab-clickable',
          {
            'TabNavigation__tab--active': selectedTab == tab
          }
        )}
        key={tab}
        onClick={() => selectTab(tab)}>
        {tab}
      </div>
    ))}
  </div>
);

class RoomNotesModal extends React.Component<any> {
  state = {
    selectedTab: NOTES_TAB
  };

  selectTab = selectedTab => {
    this.setState({selectedTab});
  };

  fetchRoomDetails = () => {
    const {roomId} = this.props.data;
    this.props.fetchRoomDetails(
      {roomId},
      this.props.storeDataExtraActions(data => ({room: data}))
    );
  };

  componentDidMount() {
    this.fetchRoomDetails();
  }

  render() {
    const {closeModal, data: {room, refetchExtraAction}} = this.props;
    const roomType = _.get(room, 'roomType');
    const roomNumber = _.get(room, 'roomNumber');
    const cleaningStatus = _.get(room, 'cleaningStatus');
    const {roomId, locationRef} = this.props.data;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.EXTRA_SMALL}
        className="RoomNotesModal">
        <Modal.Header>
          <div className="heading">Room {roomNumber}</div>
          <div className="subHeading">
            <div
              className="ellipse"
              style={{
                backgroundColor:
                  HOUSEKEEPING_STATUS_TO_COLOR_MAPPER[cleaningStatus]
              }}
            />
            <div className="status colab-bold">{cleaningStatus}</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="roomType">
            <div className="type">Room Type</div>
            <div>{roomType}</div>
          </div>
          <TabNavigation
            selectedTab={this.state.selectedTab}
            selectTab={this.selectTab}
          />
          {this.state.selectedTab == NOTES_TAB && (
            <RoomNotes
              roomId={roomId}
              locationRef={locationRef}
              refetchExtraAction={refetchExtraAction}
            />
          )}
          {this.state.selectedTab == HISTORY_TAB && (
            <RoomHistory roomId={roomId} locationRef={locationRef} />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToModalData = (_state, _data) => {
  return {};
};

const mapDispatchToProps = {fetchRoomDetails};

export default withModal(
  BASE_MODALS.ROOM_NOTES,
  mapStateToModalData,
  mapDispatchToProps
)(RoomNotesModal);
